const colorOpacityRegex = /(#[a-f0-9]{6})([a-f0-9]{2})?/i;
const smallColorRegex = /#[a-f0-9]{3}([a-f0-9])?/i;

// I included the small set of browser color names.
// The large set is all the css color names, which is a lot.
const stdColors = {
  black: "#000000",
  silver: "#c0c0c0",
  gray: "#808080",
  white: "#ffffff",
  maroon: "#800000",
  red: "#ff0000",
  purple: "#800080",
  fuchsia: "#FF00FF",
  green: "#008000",
  lime: "#00ff00",
  olive: "#808000",
  yellow: "#ffff00",
  navy: "#000080",
  blue: "#0000ff",
  teal: "#008080",
  aqua: "#00FFFF",
};

export class Color {
  // A more resilient method is to use the browser to compute the color.
  // create a div, assign the color to it, then read it back from computed style
  // or draw 1 pixel on a canvas and get pixel value (see stack overflow)
  public static create(color: string | undefined, enabled: boolean = true): null | Color {
    if (color == undefined || color == "transparent" || !enabled) {
      return null;
    }
    if (color in stdColors) {
      return new Color(stdColors[color as keyof typeof stdColors], 1.0);
    }
    if (color.length == 4 || color.length == 5) {
      const match = smallColorRegex.exec(color);
      if (match) {
        const red = color.charAt(1);
        const green = color.charAt(2);
        const blue = color.charAt(3);
        const alpha = color.charAt(4);
        const colorPart = `#${red}${red}${green}${green}${blue}${blue}`;
        const alphaPart = alpha == "" ? 1.0 : parseInt(alpha + alpha, 16) / 255;
        return new Color(colorPart, alphaPart);
      }
    }
    if (color.length == 7 || color.length == 9) {
      const match = colorOpacityRegex.exec(color);
      if (match) {
        const colorPart = match[1];
        const alphaPart = match[2] ? parseInt(match[2], 16) / 255 : 1.0;
        return new Color(colorPart, alphaPart);
      }
    }
    return null;
  }

  constructor(public readonly color: string, public readonly alpha: number) {}
  asRGB() {
    const m = this.color.match(/#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})/i);
    if (!m) return [0, 0, 0];
    return [
      parseInt(m[1], 16), // red
      parseInt(m[2], 16), // green
      parseInt(m[3], 16), // blue
    ];
  }
}
